export interface DeviceMetadata {
  id: string;
  groupId: string;
  label: string;
  active: boolean;
}

export namespace DeviceMetadata {
  export function fromMediaDeviceInfo(mediaDevice: MediaDeviceInfo, active: boolean): DeviceMetadata {
    return {
      id: mediaDevice.deviceId,
      groupId: mediaDevice.groupId,
      label: mediaDevice.label,
      active
    };
  }
}
